import { render, staticRenderFns } from "./BannerPlans.vue?vue&type=template&id=1ffb94a0&scoped=true"
import script from "./BannerPlans.vue?vue&type=script&lang=js"
export * from "./BannerPlans.vue?vue&type=script&lang=js"
import style0 from "./BannerPlans.vue?vue&type=style&index=0&id=1ffb94a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb94a0",
  null
  
)

export default component.exports